import { render, staticRenderFns } from "./staffControl.vue?vue&type=template&id=24e7b805&scoped=true"
import script from "./staffControl.vue?vue&type=script&lang=js"
export * from "./staffControl.vue?vue&type=script&lang=js"
import style0 from "./staffControl.vue?vue&type=style&index=0&id=24e7b805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7b805",
  null
  
)

export default component.exports